export default __webpack_public_path__ + "de96e18dd0d625f7e1496df300dc6783.svg";